/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EnterpriseIdDto } from './enterpriseIdDto';

export interface RetailerConfigV2Dto {
  accessRights?: Array<string>;
  email?: string;
  liveStatusAllowed?: boolean;
  owner?: EnterpriseIdDto;
}
